export default __webpack_public_path__ + "500b1eb81e8ae2adcb26bd95a505e4c4.png";